import React from "react";
import PropTypes from "prop-types";
import { isNil } from "ramda";
import { connectSearchBox } from "react-instantsearch-dom";

import { ALGOLIA_FILTERS, TEMPLATE_GROUP_TYPE_NAMES } from "enums";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import FilterAlgoliaSearch from "components/FilterAlgoliaSearch";
import AlgoliaConfigure from "components/AlgoliaConfigure";

import SearchResults from "../SearchResults";

const AlgoliaSearchBox = ({ carousel, loading, currentRefinement }) => {
  const limit = isNil(carousel) ? 0 : AlgoliaCardsPresenter.limit(carousel);
  return (
    <div>
      <AlgoliaConfigure clickAnalytics sendTokenOnlyForPaidUser hitsPerPage={limit} />
      <FilterAlgoliaSearch
        attribute={ALGOLIA_FILTERS.templateGroupTypeName}
        defaultRefinement={[TEMPLATE_GROUP_TYPE_NAMES.starringYouClip]}
      />
      {!loading && currentRefinement && <SearchResults carousel={carousel} />}
    </div>
  );
};

AlgoliaSearchBox.propTypes = {
  carousel: PropTypes.shape(),
  loading: PropTypes.bool,
  currentRefinement: PropTypes.string,
};

const SearchBox = connectSearchBox(AlgoliaSearchBox);

export default SearchBox;
